import { useDispatch, useSelector } from 'react-redux';
import { selectUserGroup, selectRole } from '../../../store/authReducer';
import { hasRole, RoleTypes } from '../../../core/components/Permission';
import {
  findPermissionRef,
  viewPermissionRefs,
} from '../../../core/components/UserGroupPermissions';
import { Task } from '../models';
import { addTaskFile, deleteTaskFile } from '../actions';
import { Files } from '../../../core/components/Files';

interface TaskMediaTabProps {
  task?: Task;
}

export const TaskMediaTab = ({ task }: TaskMediaTabProps) => {
  const dispatch = useDispatch();
  const role = useSelector(selectRole);
  const userGroup = useSelector(selectUserGroup);

  const enhancedRole = findPermissionRef(userGroup.permissions, viewPermissionRefs.admin)
    ? 'Admin'
    : role;

  const requiredRole = task?.isMasterTask ? RoleTypes.OperatorGroupAdmin : RoleTypes.SiteManager;

  const canModifyFiles = hasRole(enhancedRole, requiredRole);

  const handleAddFile = (formData: FormData) => {
    dispatch(addTaskFile({ taskId: task?.id, file: formData }));
  };

  const handleDeleteFile = (file: any) => {
    dispatch(deleteTaskFile({ fileId: file.id, taskId: task?.id }));
  };

  return (
    <div className="new-videos-tab">
      <Files
        files={task?.files ?? []}
        addFileFunction={handleAddFile}
        deleteFileFunction={handleDeleteFile}
        canAdd={canModifyFiles}
        canDelete={canModifyFiles}
      />
    </div>
  );
};
